import { TABLE_CELL } from '../../../types/BlockTypes';
export default function isSelectionAroundTable(editor) {
  if (!editor.isSelectionInTable()) {
    return false;
  }

  var selection = editor.value.selection;
  var _editor$value = editor.value,
      firstCell = _editor$value.startBlock,
      lastCell = _editor$value.endBlock;
  var tableId = firstCell.getIn(['data', 'tableId']) || lastCell.getIn(['data', 'tableId']);
  var cells = editor.getTableCells(tableId);
  var firstCellCompletelySelected = firstCell && selection.start.isAtStartOfNode(firstCell) || firstCell.type !== TABLE_CELL;
  var lastCellCompletelySelected = lastCell && selection.end.isAtEndOfNode(lastCell) || lastCell.type !== TABLE_CELL;
  return editor.value.blocks.isSuperset(cells) && firstCellCompletelySelected && lastCellCompletelySelected;
}